import File from './file';
import TriggerCategory from './triggercategory';
import Variable from './variable';
import Trigger from './trigger';
import ECA from './eca';
import Parameter from './parameter';
import SubParameters from './subparameters';
import { TriggerData } from './triggerdata';

export default {
  File,
  TriggerCategory,
  Variable,
  Trigger,
  ECA,
  Parameter,
  SubParameters,
  TriggerData,
};
